"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgEdit(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M11.986 2.067a.765.765 0 01.104 1.524l-.104.007H1.53v18.871h18.872V12.013c0-.388.288-.708.662-.759l.103-.006c.388 0 .708.287.759.66l.007.105v11.222a.765.765 0 01-.662.758l-.104.007H.765a.765.765 0 01-.758-.661L0 23.235V2.833c0-.388.288-.708.661-.759l.104-.007h11.221zM21.841.175c.503.152.943.403 1.29.774.3.32.514.701.656 1.126.197.59.239 1.19.195 1.725l-.017.16-.003.019a.766.766 0 01-.012.06l.015-.078a.77.77 0 01-.142.346l-.007.008a.766.766 0 01-.05.06l-.017.018-10.201 10.2a.762.762 0 01-.257.17l-.015.006a.762.762 0 01-.032.011l-.052.015-4.08 1.021a.765.765 0 01-.947-.823l.019-.105 1.02-4.081.015-.052a.762.762 0 01.011-.032l-.026.084a.768.768 0 01.207-.362L19.593.263c.03-.03.062-.059.096-.085l-.083.072a.77.77 0 01.433-.216l.167-.018a4.447 4.447 0 011.635.16zm-1.304 1.356l-.051.003-9.85 9.85-.66 2.638 2.639-.661 9.849-9.849.003-.05a2.787 2.787 0 00-.131-.902 1.518 1.518 0 00-.323-.566 1.355 1.355 0 00-.614-.354 2.87 2.87 0 00-.862-.109z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgEdit;
exports.default = _default;